import Mediathek from './app/mediathek';

let scrollPos = 0;
let ticking = false;

function doSomething(scroll_pos) {
    // header variable must be here
    let header = document.getElementsByClassName('navbar')[0] || null;
    if (header) {
        if (scroll_pos > 250) {
            header.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
        }
    }
}

document.addEventListener('scroll', function(e) {
    scrollPos = window.scrollY;

    if (!ticking) {
        window.requestAnimationFrame(function() {
            doSomething(scrollPos);
            ticking = false;
        });

        ticking = true;
    }
});


document.addEventListener("DOMContentLoaded", (event) => {
    let mediathek = new Mediathek();

    mediathek.init();

    window.SK = window.SK || {};
    window.SK.mediathek = mediathek;
    window.SK.helper = {
        setDefaultImage(el) {
            el.src = mediathekPublicAssetsPath + 'Images/defaultimage_small.jpg';
        }
    };
});
